import React from 'react';
import { useTranslation } from 'react-i18next';
import { Settings as SettingsIcon } from '@bb-ui/icons/dist/small';
import { NavigationRoutedLink } from '../NavigationRouting/NavigationRoutedLink';
import { NavigationRouted } from '../NavigationRouting/NavigationRouted';
import { Settings as SettingsPage } from '../Settings/Settings';
import { EditUserPage } from '../Settings/User/EditPage/EditUserPage';
import { CreateUserPage } from '../Settings/User/CreatePage/CreateUserPage';
import { useAccessControl } from '../../hooks/useAccessControl';

export const SettingsContent: React.FC<{
    navigationIndex: number;
}> = props => {
    const { t } = useTranslation();
    const access = useAccessControl();

    return (
        <NavigationRoutedLink
            key="settings"
            path="settings"
            label={t('settings.label')}
            icon={<SettingsIcon />}
            routeWithoutContext
            index={props.navigationIndex}
            access={access['developer/settings']}
        >
            <NavigationRouted>
                <SettingsPage />
            </NavigationRouted>

            {/* The Authentication tab is the same page with that tab selected,
                so the tab is linkable and survives a reload. */}
            {access['developer/settings/authentication'].ok && (
                <NavigationRouted path="authentication">
                    <SettingsPage />
                </NavigationRouted>
            )}

            {access['developer/settings/user-management'].ok && (
                <NavigationRouted path="users/:id/edit">
                    <EditUserPage />
                </NavigationRouted>
            )}
            {access['developer/settings/users'].ok && (
                <NavigationRouted path="users/create">
                    <CreateUserPage />
                </NavigationRouted>
            )}
        </NavigationRoutedLink>
    );
};
